import React from 'react';
import PropTypes from 'prop-types';
import { EmphasisTag } from '@wtag/react-comp-lib';
import Icon from '@wtag/rcl-icon';
import Amount from 'sharedWebpack/Amount';
import './styles.scss';

const NewFlightAccordionHeader = ({ priceDetails }) => {
  const { currency, amount } = priceDetails;

  return (
    <div className="d-flex align-center justify-between flex-grow flex-wrap">
      <div className="d-flex align-center column-gap-8">
        <Icon name="aeroplane" color="tertiary" showBGColor={true} size="tiny" />
        <div>{I18n.t('components.ibe.exchange.cart.flight')}</div>
        <EmphasisTag
          size="tiny"
          type="danger"
          text={I18n.t('components.ibe.results.exchange_tag.changed')}
        />
      </div>
      <Amount className="new-flight-accordion-header__amount" currency={currency} value={amount} />
    </div>
  );
};

NewFlightAccordionHeader.propTypes = {
  priceDetails: PropTypes.shape({
    currency: PropTypes.string.isRequired,
    amount: PropTypes.string.isRequired,
  }).isRequired,
};

export default NewFlightAccordionHeader;
